export default function* success(res) {}
